import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useField } from "formik";
import PTFormInput from "./PTFormInput";

export const PTRadioGroup = ({
  name,
  label,
  options,
  isHidden,
  xs = 12,
  md = 4,
  lg = 3,
  gridOptions,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <PTFormInput
      isHidden={isHidden}
      name={name}
      md={md}
      xs={xs}
      lg={lg}
      {...gridOptions}
    >
      <FormControl component="fieldset" error={meta.touched && !!meta.error}>
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup {...field} row>
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
              {...props}
            />
          ))}
        </RadioGroup>
        {meta.touched && meta.error && (
          <FormHelperText error>{meta.error}</FormHelperText>
        )}
      </FormControl>
    </PTFormInput>
  );
};

export default PTRadioGroup;
